<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Observações">
      <v-row justify="end">
        <v-col cols="6">
          <create-analysis-observation-modal
            :loading="isLoading"
            @success="success($event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <analysis-table-comments-list
            ref="list"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import AnalysisTableCommentsList from 'Modules/contacard/analysisTable/components/tables/AnalysisTableCommentsList.vue';
import CreateAnalysisObservationModal from 'Modules/contacard/analysisTable/components/modals/CreateAnalysisObservationModal.vue';

export default {
  name: 'AnalysisObservationCard',
  components: { AnalysisTableCommentsList, CreateAnalysisObservationModal },
  mixins: [AnalysisCardMixin],
  computed: {
    reloadList() {
      const { list } = this.$refs;
      return list ? list.getData : () => {};
    },
  },
  methods: {
    success(ev) {
      if (ev) {
        this.reloadList();
      }
    },
  },
};
</script>
